<div class="pt-24">
  <app-goole-calendar-config></app-goole-calendar-config>
  <!-- It is hidden because this feature is not available yet -->
  <!-- <form [formGroup]="form">
    <ng-container *ngFor="let item of configs">
      <div class="flex-row-container justify-between items-center pt-24">
        <div class="flex-col-container gap-8">
          <span class="fs-16">{{ 'USER.CONFIG.' + item.label + '.TITLE' | translate }}</span>
          <span>{{ 'USER.CONFIG.' + item.label + '.STATEMENT' | translate }}</span>
        </div>
        <ng-container [ngSwitch]="item.type">
          <ng-container *ngSwitchCase="'boolean'">
            <div class="mr-32">
              <mat-slide-toggle color="primary" [formControlName]="item.id"></mat-slide-toggle>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </form> -->
</div>
